/*******************************************************************************

  Project: ICR
  Author:  What.Digital
  Date:    Jan 2021

********************************************************************************

TOC:
  GDPR
  Fixed Header
  Text Slider
  Testimonial
  Tooltip
  Popover

*******************************************************************************/

jQuery( document ).ready(function($) {

    /* Parallax
    ------------------------------------------------------------------------------*/
	(function($) {
	  var parallax = 0.5;

	  var $bg_images = $(".hero .shape, .text-bg");
	  
	  var offset_tops = [];
	  $bg_images.each(function(i, el) {
		offset_tops.push($(el).offset().top);
	  });

	  $(window).scroll(function() {
		var dy = $(this).scrollTop();
		$bg_images.each(function(i, el) {
		  var ot = offset_tops[i];
		  $(el).css("background-position", "50% " + (dy - ot) * parallax + "px");
		});

	  });
	})(jQuery);	
	
	//GDPR
	$(".cookie div a").click(function(){
		$(".cookie").addClass("act");
		return false;
	});	

	$(".card_block h4").css({'height':($(".card_block h4").height()+'px')});

	$(".hamburger").click(function(){
		$("body").toggleClass("nav-act");
	});

	$("#menu-mainmenu li a.active").parent().parent().addClass("active-item");
	$(".card_block ul").parent().parent().addClass("no-link");

	// Fixed Header
	$(window).scroll(function() {
		var value = $(this).scrollTop();
		if (value > 80) {
			$("header").addClass("fixed");
		} else {
			$("header").removeClass("fixed");
            $("header").removeClass("nav-up");
		}
	});	
	
	
	// Text Slider
	$('.text-slider').slick({
		infinite: true,
		dots: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow:"<button type='button' class='slick-prev pull-left'><img src='/wp-content/themes/icrpd/assets/img/prev.svg' class='img-fluid' alt='' /></button>",
		nextArrow:"<button type='button' class='slick-next pull-right'><img src='/wp-content/themes/icrpd/assets/img/next.svg' class='img-fluid' alt='' /></button>",
		appendDots: $('.custom-dots-one'),
		responsive: [
		{
		  breakpoint: 1025,
		  settings: {	
			  arrows: false
		  }
		}
	  ]		
	});
	
	$('.text-slider-two').slick({
		infinite: true,
		dots: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow:"<button type='button' class='slick-prev pull-left'><img src='/wp-content/themes/icrpd/assets/img/prev.svg' class='img-fluid' alt='' /></button>",
		nextArrow:"<button type='button' class='slick-next pull-right'><img src='/wp-content/themes/icrpd/assets/img/next.svg' class='img-fluid' alt='' /></button>",
		appendDots: $('.custom-dots-two'),
		responsive: [
		{
		  breakpoint: 1025,
		  settings: {	
			  arrows: false
		  }
		}
	  ]		
	});	
		
	// Testimonial
	$('.testominial-slider').slick({
		infinite: true,
		dots: true,
		slidesToShow: 1,
		slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 900,		
		prevArrow:"<button type='button' class='slick-prev pull-left'><img src='/wp-content/themes/icrpd/assets/img/prev.svg' class='img-fluid' alt='' /></button>",
		nextArrow:"<button type='button' class='slick-next pull-right'><img src='/wp-content/themes/icrpd/assets/img/next.svg' class='img-fluid' alt='' /></button>",
		responsive: [
			{
			breakpoint: 1025,
			settings: {
			  arrows: false
			}
		}
		]		
	});	

	/* Tooltip
	------------------------------------------------------------------------------*/	
	$('[data-toggle="tooltip"]').tooltip()
	
	/* Popover
	------------------------------------------------------------------------------*/	
	$('[data-toggle="popover"]').popover()
	
	/* Cookies
	------------------------------------------------------------------------------*/	
	const cookieBox = document.getElementById('js-cookie-box');
	const cookieButton = document.getElementById('js-cookie-button');
	if (!Cookies.get('cookie-box')) {
		cookieBox.classList.remove('hide-cookie');
		cookieButton.onclick = function() {
			Cookies.set('cookie-box', true, { expires: 30 });
			cookieBox.classList.add('hide-cookie');
		}
	}

	/* Newsletter
	------------------------------------------------------------------------------*/	
	$( document ).on( 'click', '.newsletter input[type="checkbox"]', function( event ) {
		if($(this).is(':checked')) {
			$('.newsletter input[type="submit"]').addClass('enable');
		} else {
			$('.newsletter input[type="submit"]').removeClass('enable');
		}
	})

	$( document ).on( 'keyup', '.newsletter input[type="text"]', function( event ) {
		if($('.newsletter input[type="checkbox"]').is(":checked")) {
			$('.newsletter input[type="submit"]').addClass('enable');
		} else {
			$('.newsletter input[type="submit"]').removeClass('enable');
		}
	})	

	/* External Links
	------------------------------------------------------------------------------*/

	$(document).ready(function() {
		var website = window.location.hostname;
		var internalLinkRegex = new RegExp('^((((http:\\/\\/|https:\\/\\/)(www\\.)?)?' +
				website +
				')|(localhost:\\d{4})|(\\/.*))(\\/.*)?$', '');

		$('a:not([data-toggle="popover"]):not([href*="#"]):not([href*="tel"]):not([href*="mailto"]):not(.footer-social-media__linkedin):not(.footer-social-media__youtube):not(.disable-external-icon):not([data-lity])').filter(function() {
						var href = $(this).attr('href');
						return !internalLinkRegex.test(href);
				})
				.each(function() {
						$(this).attr('target', '_blank');
						$(this).addClass('external-link');
				});
	});
	
	/* Parallax
	------------------------------------------------------------------------------*/	
	var bg = $('.hero .shape');
	 $(window).scroll(function() {
	   var x = $(this).scrollTop();
	   bg.css('background-position', '50% ' +  parseInt(-x / 8) + 'px');
	});	

	/* Logo Slider
	------------------------------------------------------------------------------*/

	$('.clients-slider').slick({
		infinite: true,
		dots: false,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 900,
		slidesToShow: 4,
		slidesToScroll: 1,
		prevArrow: "<button type='button' class='slick-prev pull-left'><img src='/wp-content/themes/icrpd/assets/img/prev.svg' class='img-fluid' alt='' /></button>",
		nextArrow: "<button type='button' class='slick-next pull-right'><img src='/wp-content/themes/icrpd/assets/img/next.svg' class='img-fluid' alt='' /></button>",
		responsive: [{
						breakpoint: 1024,
						settings: {
								slidesToShow: 3,
								slidesToScroll: 3,
								dots: true,
								arrows: false,
						}
				},
				{
						breakpoint: 767,
						settings: {
								slidesToShow: 3,
								slidesToScroll: 3,
								dots: true,
								arrows: false,
						}
				},
				{
						breakpoint: 575,
						settings: {
								slidesToShow: 3,
								slidesToScroll: 1,
								dots: true,
								arrows: false,
			speed: 300,
						}
				}
		]
	});

	/* Form Validation
	------------------------------------------------------------------------------*/	
	$('.popup form input[type="submit"]').css('pointer-events', 'none');
	$('.popup form input').keyup(function() {

	 var empty = false;
	  $('form input[aria-required="true"]').each(function() {
		if ($(this).val() == '') {
			empty = true;
		}
	 });

	  if (empty) {
		 $('.popup form input[type="submit"]').css('pointer-events', 'none');
		 $('.popup form input[type="submit"]').removeClass('active');
	  } else {
		 $('.popup form input[type="submit"]').css('pointer-events', 'inherit');
		 $('.popup form input[type="submit"]').addClass('active');
	  }
	});
	
	AOS.init({
		once: true
	});

	$(".text-slider .slick-slide:nth-child(2)").find(".custom-dots-one li:first-child").addClass("active");
	$(".text-slider .slick-slide:nth-child(3)").find(".custom-dots-one li:nth-child(2)").addClass("active");
	$(".text-slider .slick-slide:nth-child(4)").find(".custom-dots-one li:nth-child(3)").addClass("active");

	$(".text-slider-two .slick-slide:nth-child(2)").find(".custom-dots-two li:first-child").addClass("active");
	$(".text-slider-two .slick-slide:nth-child(3)").find(".custom-dots-two li:nth-child(2)").addClass("active");
	$(".text-slider-two .slick-slide:nth-child(4)").find(".custom-dots-two li:nth-child(3)").addClass("active");
	
	// Video controlling with Froogaloop librray
	var iframe_video = document.getElementById('vi-banner-video');
	if(typeof(iframe_video) != 'undefined' && iframe_video != null) {
		var player = $f(iframe_video);
		player.api("pause");
	
		$( document ).on( 'click', '.js-video-control', function( event ) {
			player.api("pause");
			$(".video-wrapper").addClass("paused");
			$(this).addClass("paused");
			return false;
		})
	
		$( document ).on( 'click', '.js-video-control.paused', function( event ) {
			player.api("play");
			$(".video-wrapper").removeClass("paused");
			$(this).removeClass("paused");
			return false;
		})
	}

});
(function() {

	var doc = document.documentElement;
	var w = window;

	var curScroll;
	var prevScroll = w.scrollY || doc.scrollTop;
	var curDirection = 0;
	var prevDirection = 0;

	var header = document.getElementById('header');
	var header2 = document.getElementById('header2');
	var toggled;
	var threshold = 70;

	var checkScroll = function() {
		curScroll = w.scrollY || doc.scrollTop;
		if (curScroll > prevScroll) {
			curDirection = 2;
		} else {
			curDirection = 1;
		}

		if (curDirection !== prevDirection) {
			toggled = toggleHeader();
		}

		prevScroll = curScroll;
		if (toggled) {
			prevDirection = curDirection;
		}
	};
	
	var toggleHeader = function() {
		toggled = true;
		if (curDirection === 2 && curScroll > threshold) {
			header.classList.remove('nav-up');
			header2.classList.remove('nav-up');
		} else if (curDirection === 1) {
			header.classList.add('nav-up');
			header2.classList.add('nav-up');
		} else {
			toggled = false;
		}
		return toggled;
	};

	window.addEventListener('scroll', checkScroll);

})();	